// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3mizq","content":"Consent_content__6y9dq","footer":"Consent_footer__LFztf"};